import { Icon, IconName } from "@nju/icons";
import { Text } from "@nju/ui";

interface ITitleProps {
  title: string;
  iconName: IconName;
}

export function Title({ title, iconName }: ITitleProps) {
  return (
    <div className="flex only-mobile:items-center">
      <Icon
        className="w-[27px] h-[24px] mr-3 from-tablet:w-[32px] from-tablet:h-[29px]"
        name={iconName}
        tone="accent"
      />
      <Text
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "xl",
        }}
        weight="bold"
      >
        {title}
      </Text>
    </div>
  );
}
